import { z } from "zod/v4";

import { UserInterfaceDtoSchema } from "../../../dtos/user-interfaces";

export const PutUserInterfaceRequestBodySchema = z.object({
  variationId: z.uuid(),
  userInterface: UserInterfaceDtoSchema,
});

export type PutUserInterfaceRequestBodyType = z.infer<
  typeof PutUserInterfaceRequestBodySchema
>;

export const PutUserInterfaceResponseBodySchema = z.object({
  userInterface: UserInterfaceDtoSchema,
});
export type PutUserInterfaceResponseBodyType = z.infer<
  typeof PutUserInterfaceResponseBodySchema
>;
